import { FC, InputHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';
import style from './PartialsStyle.module.css';

interface PairTextInputProps {
  name1: string;
  name2: string;
  label: string;
  error?: string;
  required?: boolean;
  props1?: InputHTMLAttributes<HTMLInputElement>;
  props2?: InputHTMLAttributes<HTMLInputElement>;
}

export const PairTextInput: FC<PairTextInputProps> = ({
  name1,
  name2,
  label,
  error = '',
  required = false,
  props1 = {},
  props2 = {},
}) => {
  const { register } = useFormContext();
  return (
    <div
      className={`${style['input-text']} ${
        !!error ? style['input-text-error'] : ''
      }`}
    >
      <label>
        {label}
        <span
          className={`${style['input-label-tips']} ${
            required && style['required']
          }`}
        >
          {required ? '必須' : '任意'}
        </span>
      </label>
      <div className={style['input-pair']}>
        <input {...props1} {...register(name1)} />
        <input {...props2} {...register(name2)} />
      </div>
      {!!error && <p className={style['input-error-message']}>{error}</p>}
    </div>
  );
};
